// extracted by mini-css-extract-plugin
module.exports = {"container":"Editor_container__jcQFw","padded":"Editor_padded__1NLdF","tabs":"Editor_tabs__2vTvS","saveStatus":"Editor_saveStatus__3P2Yc"};